module.exports = __webpack_public_path__ + "media/images/story_ogp_image/episode_reserved_publication-006fb82a1f60763bfa7615187d0f456c.png";